<template>
  <layout-content>
    <div class="row dashboard-card-row">
      <template v-for="item in dashboard_items">
        <dashboard-item v-if="!item.is_additional" :key="item.name" :item="item" />
        <dashboard-item
          v-if="!!item.is_additional && locale === 'ru'"
          :key="item.name"
          :item="item"
        />
        <!-- <dashboard-item v-else-if="!!item.is_additional && locale === 'ru'" :item="item" /> -->
      </template>
    </div>

    <first-entry v-if="modal_showing" @close_first_entry="close_modal" />
  </layout-content>
</template>

<script>
  import { mapGetters } from 'vuex';
  import FirstEntry from './modal/first-entry.vue';
  import items from './dashboard-items';
  import DashboardItem from './dashboard-item';

  export default {
    components: { FirstEntry, DashboardItem },
    data: () => ({
      modal_showing: false,
      locale: '',
      loading: false,
      is_predictive_allow: {
        init: false,
        permission: 0
      }
    }),
    computed: {
      ...mapGetters('core/auth', ['user']),

      dashboard_items() {
        return items;
      }
    },

    watch: {
      '$i18n.locale': function (newVal) {
        this.locale = newVal;
      }
    },

    mounted() {
      window.history.replaceState(null, null, window.location.origin);
      this.first_entry();
      this.locale = this.$i18n.locale;
    },

    methods: {
      first_entry() {
        if (localStorage.firstEntry && this.user.user_key === localStorage.userKey) {
          this.modal_showing = true;
        }
      },
      close_modal() {
        this.modal_showing = false;
      }
    }
  };
</script>

<style lang="scss">
  .dashboard-card-row {
    .col-6 {
      margin-bottom: 30px;
    }
  }
</style>
